var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChandigarh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.729,
    height: 59.869,
    viewBox: "0 0 65.729 59.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(-2332.75 -160.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20371",
    "data-name": "Path 20371",
    d: "M2398.479,212.523v1.155a1.654,1.654,0,0,1-1.457.594q-9.974-.018-19.949-.008h-.832c.192.3.3.483.415.657.769,1.157,1.551,2.3,2.306,3.47.551.851.169,1.578-.842,1.644-.213.014-.428.006-.642.006H2353.3a1.156,1.156,0,0,1-1.16-.518,1.1,1.1,0,0,1,.2-1.245q1.056-1.569,2.1-3.146c.169-.255.33-.514.556-.867h-.9q-9.943,0-19.885.008a1.646,1.646,0,0,1-1.457-.593v-1.155c.048-.138.1-.274.143-.413a4.68,4.68,0,0,1,3.09-3.337.772.772,0,0,0,.631-.89q-.027-12.1-.013-24.193v-.617a.884.884,0,0,0-.132-.1,2.9,2.9,0,0,1-.135-5.291.726.726,0,0,0,.255-.561c.022-1.39.01-2.781.012-4.171,0-1.005.293-1.3,1.292-1.306,2.16,0,4.321.013,6.481-.015a2.482,2.482,0,0,0,1.143-.3q9.574-5.4,19.122-10.851a1.732,1.732,0,0,1,1.951-.007q9.542,5.458,19.12,10.853a2.479,2.479,0,0,0,1.14.3c2.2.029,4.406.008,6.61.017.835,0,1.162.34,1.166,1.173.007,1.433-.013,2.867.019,4.3a.876.876,0,0,0,.369.614,3.021,3.021,0,0,1,1.426,1.817c.384,1.421-.2,2.579-1.782,3.5a.65.65,0,0,0-.024.125q0,12.481-.013,24.963c0,.349.134.457.448.56a4.731,4.731,0,0,1,3.289,3.537A1.964,1.964,0,0,0,2398.479,212.523Zm-49.294-41.039.026.105h32.983c-.218-.141-.3-.2-.391-.251q-7.883-4.478-15.764-8.964a.763.763,0,0,0-.874.029q-3.836,2.2-7.687,4.372Zm-2.932,5.858h38.709v-3.724h-38.709Zm27.141,27.261a1.169,1.169,0,0,0,.045-.19q0-8.533-.011-17.066a.7.7,0,0,0-.4-.494,4.8,4.8,0,0,1-3.188-3.174.589.589,0,0,0-.672-.49q-3.561.025-7.122,0c-.4,0-.544.157-.658.508a4.581,4.581,0,0,1-3.089,3.093c-.456.147-.523.359-.522.769q.016,8.212.009,16.424c0,.2.024.407.037.617h1.888v-.729c0-3.636-.023-7.271.009-10.907a5.659,5.659,0,0,1,3.081-5.192,5.877,5.877,0,0,1,8.708,5.081c.049,3.678.011,7.357.012,11.035v.716Zm-7.773-25.258h-27.528c-1.035,0-1.506.311-1.487.98.018.646.478.945,1.472.945q27.528,0,55.056,0a3.325,3.325,0,0,0,.764-.06.935.935,0,0,0-.047-1.827,4.365,4.365,0,0,0-.767-.035Zm27.059,3.853c-1.875,0-3.691-.014-5.506.023-.169,0-.409.3-.486.513a4.688,4.688,0,0,1-3.074,3.04c-.487.155-.549.387-.548.817q.017,8.183.009,16.366c0,.206.019.413.029.624h9.576Zm-54.121,0v21.4h9.554a2.181,2.181,0,0,0,.039-.28q0-8.472.01-16.944c0-.357-.148-.456-.457-.554a4.1,4.1,0,0,1-2.855-2.476c-.365-1.071-.958-1.229-1.916-1.161-1.021.073-2.052.016-3.079.016Zm13.447,25.253V207.7q0-6.19,0-12.38a3.256,3.256,0,0,1,.016-.576.955.955,0,0,1,1.892,0,3.053,3.053,0,0,1,.017.576q0,6.222,0,12.444c0,.225.019.449.03.683h1.852V187.083h-1.883v.66c0,1,.009,2.01-.006,3.015,0,.249,0,.6-.153.721a1.706,1.706,0,0,1-1.023.442c-.493-.03-.74-.458-.741-.969,0-1.278,0-2.556,0-3.857h-1.9V208.45Zm27.216-21.382v.7c0,1.069.013,2.138-.007,3.207a.957.957,0,0,1-.947,1.006.968.968,0,0,1-.968-.985c-.015-.234,0-.47,0-.706,0-1.063,0-2.126,0-3.209h-1.887v21.357h1.887v-.753q0-6.158,0-12.316a3.3,3.3,0,0,1,.019-.64.954.954,0,0,1,1.882-.02,2.975,2.975,0,0,1,.023.639q0,6.19,0,12.38v.718h1.872V187.068Zm-9.655,6.885h-7.906V204.6h7.906Zm6.869,24.119c-.842-1.262-1.622-2.453-2.435-3.62a.784.784,0,0,0-.566-.18q-7.823-.014-15.646,0a.778.778,0,0,0-.563.185c-.813,1.166-1.593,2.356-2.434,3.615Zm19.941-5.776a6.824,6.824,0,0,0-.364-.665,3.021,3.021,0,0,0-2.677-1.224c-5.753.013-11.505.005-17.258.007-.224,0-.448.022-.667.033V212.3Zm-40.553-1.85c-.183-.014-.311-.031-.438-.032q-8.822,0-17.643,0a4.686,4.686,0,0,0-.7.051,2.506,2.506,0,0,0-2.072,1.837h20.856Zm17.6-3.831h-15.6v1.822h15.6Zm0,3.852h-15.6v1.821h15.6Zm-34.877-33.1h5.717v-3.746h-5.717Zm54.109.01V173.6h-5.7v3.774Zm-33.226,5.863h-12.968a2.886,2.886,0,0,0,.153.4,2.973,2.973,0,0,0,2.8,1.483c1.817,0,3.635,0,5.452,0,.791,0,1.584.008,2.37-.063A2.52,2.52,0,0,0,2359.43,183.242Zm25.291,0h-12.906c-.01.084-.029.131-.016.165a1.739,1.739,0,0,0,.135.288,2.987,2.987,0,0,0,2.764,1.427c1.8,0,3.592,0,5.388,0,.812,0,1.627.009,2.434-.063A2.521,2.521,0,0,0,2384.721,183.242Zm-36.587,23.373h-9.566v1.82h9.566Zm34.96,1.82h9.568v-1.82h-9.568Zm-13.659-16.469a3.9,3.9,0,0,0-4.146-2.975,3.743,3.743,0,0,0-3.445,2.975Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20372",
    "data-name": "Path 20372",
    d: "M2428.767,181.532l8.293-4.71q3.845-2.183,7.687-4.372a.763.763,0,0,1,.874-.029q7.874,4.5,15.764,8.964c.089.051.173.111.391.251h-32.983Z",
    transform: "translate(-79.582 -10.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20373",
    "data-name": "Path 20373",
    d: "M2411.636,242.437v-3.724h38.709v3.724Z",
    transform: "translate(-65.383 -65.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20374",
    "data-name": "Path 20374",
    d: "M2494.574,316.034H2492.7v-.716c0-3.678.036-7.357-.012-11.035a5.877,5.877,0,0,0-8.708-5.081,5.66,5.66,0,0,0-3.081,5.192c-.032,3.635-.009,7.271-.009,10.907v.729H2479c-.013-.211-.037-.414-.037-.617q0-8.212-.009-16.424c0-.41.066-.622.522-.769a4.581,4.581,0,0,0,3.089-3.093c.114-.351.256-.512.658-.508q3.561.029,7.121,0a.589.589,0,0,1,.672.49,4.8,4.8,0,0,0,3.188,3.174.7.7,0,0,1,.4.494q.029,8.533.011,17.066A1.169,1.169,0,0,1,2494.574,316.034Z",
    transform: "translate(-121.181 -111.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20375",
    "data-name": "Path 20375",
    d: "M2384.293,272.173h27.464a4.37,4.37,0,0,1,.767.035.935.935,0,0,1,.047,1.827,3.321,3.321,0,0,1-.764.06q-27.528,0-55.056,0c-.994,0-1.454-.3-1.472-.945-.019-.669.452-.98,1.487-.98Z",
    transform: "translate(-18.672 -92.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20376",
    "data-name": "Path 20376",
    d: "M2636.321,294.669v21.384h-9.576c-.01-.212-.029-.418-.029-.624q0-8.183-.009-16.366c0-.43.061-.662.548-.817a4.687,4.687,0,0,0,3.074-3.04c.077-.21.316-.51.486-.513C2632.63,294.655,2634.446,294.669,2636.321,294.669Zm-7.681,12.442q0,2.884,0,5.768c0,.964.3,1.287,1.246,1.3q1.634.02,3.268,0c.948-.01,1.26-.334,1.261-1.284q0-5.64,0-11.279a2.893,2.893,0,1,0-5.774-.015C2628.636,303.437,2628.64,305.274,2628.64,307.111Z",
    transform: "translate(-243.64 -111.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20377",
    "data-name": "Path 20377",
    d: "M2366.689,294.527h1.3c1.027,0,2.058.056,3.079-.016.958-.068,1.552.091,1.916,1.161a4.1,4.1,0,0,0,2.855,2.477c.309.1.458.2.457.554q-.017,8.472-.01,16.944a2.181,2.181,0,0,1-.039.28h-9.554Zm7.67,12.459c0-1.859.006-3.717,0-5.576a2.889,2.889,0,1,0-5.773-.015q-.011,5.7,0,11.407c0,.9.327,1.224,1.245,1.235q1.634.019,3.268,0c.948-.01,1.26-.334,1.262-1.284Q2374.363,309.87,2374.359,306.986Z",
    transform: "translate(-28.13 -111.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20378",
    "data-name": "Path 20378",
    d: "M2436.064,338.744h-1.9V317.389h1.9c0,1.3,0,2.579,0,3.857,0,.511.248.939.741.969a1.707,1.707,0,0,0,1.023-.442c.15-.12.149-.473.153-.721.016-1,.006-2.01.006-3.015v-.66h1.883v21.367h-1.852c-.011-.234-.03-.459-.03-.683q0-6.222,0-12.444a3.013,3.013,0,0,0-.017-.576.954.954,0,0,0-1.892,0,3.233,3.233,0,0,0-.016.576q0,6.19,0,12.38Z",
    transform: "translate(-84.057 -130.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20379",
    "data-name": "Path 20379",
    d: "M2585.786,317.29h1.872v21.376h-1.872v-.718q0-6.19,0-12.38a2.991,2.991,0,0,0-.023-.639.954.954,0,0,0-1.883.02,3.3,3.3,0,0,0-.019.64q0,6.158,0,12.316v.754h-1.887V317.3h1.887c0,1.084,0,2.146,0,3.209,0,.235-.011.471,0,.706a.969.969,0,0,0,.968.985.957.957,0,0,0,.947-1.006c.019-1.069.006-2.138.007-3.207Z",
    transform: "translate(-206.563 -130.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20380",
    "data-name": "Path 20380",
    d: "M2509.562,357.515v10.644h-7.906V357.515Z",
    transform: "translate(-139.994 -163.561)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20381",
    "data-name": "Path 20381",
    d: "M2483.171,479.985h-21.644c.841-1.259,1.621-2.449,2.434-3.615a.778.778,0,0,1,.563-.185q7.823-.015,15.646,0a.784.784,0,0,1,.566.18C2481.549,477.532,2482.33,478.723,2483.171,479.985Z",
    transform: "translate(-106.734 -261.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20382",
    "data-name": "Path 20382",
    d: "M2602.956,455.528h-20.965v-1.849c.218-.011.442-.033.667-.033,5.753,0,11.506.005,17.258-.007a3.021,3.021,0,0,1,2.676,1.224A6.874,6.874,0,0,1,2602.956,455.528Z",
    transform: "translate(-206.578 -243.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20383",
    "data-name": "Path 20383",
    d: "M2366.572,453.709v1.858h-20.856a2.506,2.506,0,0,1,2.072-1.837,4.688,4.688,0,0,1,.7-.051q8.822,0,17.643,0C2366.261,453.678,2366.388,453.7,2366.572,453.709Z",
    transform: "translate(-10.747 -243.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20384",
    "data-name": "Path 20384",
    d: "M2494.836,431.483V433.3h-15.6v-1.822Z",
    transform: "translate(-121.412 -224.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20385",
    "data-name": "Path 20385",
    d: "M2494.838,453.985v1.821h-15.6v-1.821Z",
    transform: "translate(-121.414 -243.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20386",
    "data-name": "Path 20386",
    d: "M2366.619,242.483v-3.746h5.718v3.746Z",
    transform: "translate(-28.072 -65.115)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20387",
    "data-name": "Path 20387",
    d: "M2655.14,242.408h-5.7v-3.774h5.7Z",
    transform: "translate(-262.484 -65.029)",
    fill: "#04a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20388",
    "data-name": "Path 20388",
    d: "M2425.823,294.934a2.52,2.52,0,0,1-2.2,1.816c-.786.071-1.58.059-2.37.063-1.818.008-3.635,0-5.452,0a2.661,2.661,0,0,1-2.948-1.881Z",
    transform: "translate(-66.393 -111.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20389",
    "data-name": "Path 20389",
    d: "M2573.783,294.936a2.521,2.521,0,0,1-2.2,1.815c-.807.072-1.623.059-2.434.063-1.8.008-3.593,0-5.388,0A2.987,2.987,0,0,1,2561,295.39a1.7,1.7,0,0,1-.135-.288c-.013-.035.006-.081.016-.165Z",
    transform: "translate(-189.061 -111.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20390",
    "data-name": "Path 20390",
    d: "M2376.306,431.487v1.82h-9.566v-1.82Z",
    transform: "translate(-28.172 -224.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20391",
    "data-name": "Path 20391",
    d: "M2626.868,433.307v-1.82h9.568v1.82Z",
    transform: "translate(-243.773 -224.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20392",
    "data-name": "Path 20392",
    d: "M2510.31,331.437h-7.592a3.742,3.742,0,0,1,3.445-2.975A3.9,3.9,0,0,1,2510.31,331.437Z",
    transform: "translate(-140.875 -139.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20393",
    "data-name": "Path 20393",
    d: "M2637.993,325.779c0-1.837,0-3.674,0-5.511a2.894,2.894,0,1,1,5.774.015q.007,5.639,0,11.279c0,.95-.313,1.274-1.261,1.284q-1.634.018-3.268,0c-.942-.011-1.244-.335-1.246-1.3Q2637.989,328.663,2637.993,325.779Zm3.851,5.107V330.2q0-4.843,0-9.687a3.1,3.1,0,0,0-.017-.576.9.9,0,0,0-.922-.814.91.91,0,0,0-.974.83,2.031,2.031,0,0,0-.012.384q0,5,0,10.008c0,.167.018.334.03.536Z",
    transform: "translate(-252.993 -130.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20394",
    "data-name": "Path 20394",
    d: "M2383.517,325.794q0,2.884,0,5.768c0,.949-.314,1.273-1.261,1.284q-1.634.018-3.268,0c-.917-.011-1.244-.339-1.245-1.235q0-5.7,0-11.407a2.889,2.889,0,1,1,5.772.015C2383.523,322.077,2383.517,323.936,2383.517,325.794Zm-1.926,5.088v-1.5q0-4.555,0-9.11c0-.718-.344-1.131-.923-1.153-.613-.023-1,.4-1,1.14-.006,2.224,0,4.448,0,6.672v3.947Z",
    transform: "translate(-37.287 -130.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20395",
    "data-name": "Path 20395",
    d: "M2651.163,340.266h-1.895c-.012-.2-.03-.369-.03-.536q0-5,0-10.008a2.031,2.031,0,0,1,.012-.384.91.91,0,0,1,.974-.83.9.9,0,0,1,.922.814,3.14,3.14,0,0,1,.017.576q0,4.844,0,9.687Z",
    transform: "translate(-262.312 -139.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20396",
    "data-name": "Path 20396",
    d: "M2390.92,340.238h-1.926v-3.947c0-2.224,0-4.448,0-6.672,0-.74.385-1.163,1-1.14.579.022.921.435.923,1.153q.007,4.555,0,9.11Z",
    transform: "translate(-46.616 -139.494)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChandigarh);
export default __webpack_public_path__ + "static/media/chandigarh.f9e3509c5e4b990f2a0b461d3e1ef36d.svg";
export { ForwardRef as ReactComponent };